import {create} from 'zustand'

export const useImageViewerData = create(set => ({
  imageViewerData: {},
  onSetImageViewerData: imageViewerData => set({imageViewerData}),
}))
